<!-- 培训讲师查询 -->
<template>
    <div v-if="show">  
        <el-row class="mg-b-20">
            <el-button type="primary" icon="el-icon-plus" @click="addDialog">新增培训讲师</el-button>
        </el-row>
        <el-table border :data="tableData" style="width: 100%;">            
            <el-table-column  prop="sponsorName"  label="讲师名称"  width="180"/>
            <el-table-column  prop="sponsorId"    label="讲师账号"/>
            <el-table-column  prop="des"  label="讲师描述"/>
            <el-table-column  fixed="right" label="操作"  width="120">
                <template slot-scope="scope" >
                    <el-button @click="updateDialog(scope.row)" type="text" size="medium">修改</el-button>
                    <el-button @click="deleteDialog(scope.row)" type="text" size="medium">删除</el-button>
                </template>                   
            </el-table-column>
        </el-table>
    <!-- 新增修改对话框 -->
    <el-dialog :title="titleSponsor" :visible.sync="open" width="600px" append-to-body>
        <el-form ref="form" :model="form" :rules="rules" label-width="120px">      
            <el-form-item label="讲师名称" prop="sponsorName">
                <el-autocomplete style="width: 100%;" :clearable="true"
                    v-model="form.sponsorName"
                    :fetch-suggestions="querySearch"
                    placeholder=""
                    :trigger-on-focus="false"
                    @select="handleSelect"
                ></el-autocomplete>
            </el-form-item>       
            <el-form-item label="讲师描述" prop="des">
                <el-input type="textarea" :rows="5" v-model="form.des"  placeholder="请输入讲师描述"/>
            </el-form-item>      
            <el-form-item label="讲师图片" prop="image1">
                <el-upload  
                    ref="coverPicUpload1" action="" 
                    list-type="picture" 
                    accept="image/*"
                    multiple :limit="1" name="file" 
                    :file-list="fileList1"
                    :on-remove="handleRemove1"
                    :http-request="handleRequest1"
                    :before-upload="handleBeforeUpload" 
                    :on-error="handleUploadError">
                    <el-button size="small" type="primary">上传图片</el-button>
            </el-upload>       
            </el-form-item>       
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm">确 定</el-button>
            <el-button @click="cancel">取 消</el-button>
        </div>
    </el-dialog>
</div>
</template>
<script>

export default {
    props: {
        publishId: {
            type: String,
            default: ''
        },
        trainId: {
            type: Number,
            default: 1
        },
        show:{
            type: Boolean,
            default:false
        }
    },
    data() {
        return {
            form: {
                index: '',
                image1: '',
            },
            queryParams: {
                page: 1,
                pagesize: 10
            },
            tableData: [],  
            amount: 0,  
            total: 0,
            titleSponsor: '',
            open: false,
            rules:{
                sponsorName: [
                    { required: true, message: "请输入讲师名称", trigger: "blur" }
                ],
                sponsorId: [
                    { required: false, message: "请输入讲师账号", trigger: "blur" }
                ],
                des: [
                    { required: true, message: "请输入讲师描述", trigger: "blur" }
                ],
            },
            userInfoOption:[],            
            fileList1: [],
        }   
    },
    created() {
        // this.initData()
    },
    mounted() {

    },
    computed:{
        title(){
            return this.$route.meta.title
        }    
    },
    methods: {
        initData(id){
            let params = {
                opcode:this.$code.TeacherQuery,                
                i_serial_train:  this.publishId,
                id:id,
                i_lecturer_no: '',
                v_lecturer_name: ''
            };
            this.$api.requestAPI(params).then(res =>{
                if(res.IsSuccess){                 
                    if(res.Data.SumCount > 0){                        
                        let result = res.Data.DataTable;

                        this.tableData = result.map(item =>{
                            return{
                                index: item['序号'],
                                sponsorId: item['培训讲师账号'],
                                serialMark: item['培训标识'],
                                sponsorName: item['培训讲师名称'],
                                serial: item['培训详情序号'],
                                des: item['培训讲师描述'],
                                image1: item['图片'],
                            }
                        })
                        console.log(result)
                    }else{
                        this.tableData = []
                    }
                }
            }).catch(error =>{
                console.log(error);
            })
        },
        addDialog(){
            this.form = {
                sponsorName: '',
                image1: '',
            }
            this.fileList1 = [],
            this.form.image1 = ''
            this.titleSponsor = '新增培训讲师'
            this.open = true
            this.flag = 1
        },
        updateDialog(row){
            this.open = true
            this.titleSponsor = '修改培训讲师'
            this.flag = 2
            this.form = {...row}
            this.fileList1 = [
                {name:'',url: this.form.image1 }
            ]
        },
        deleteDialog(row){
            this.flag = 3
            this.form = {...row}
            this.$confirm(`确认删除 ${row.sponsorName} 培训讲师吗？`).then(res=>{
                this.submitForm()
            }).catch(err=>{
                console.log("取消")
            })
        },
        submitForm(){
            let params = {
                opcode:this.$code.TeacherAddOrUpdate,
                i_serial_train: this.publishId,
                id: this.trainId,
                i_serial: this.form.index,
                v_lecturer_name: this.form.sponsorName,
                i_lecturer_no: this.form.sponsorId,
                v_lecturer_duties: this.form.des,
                i_flag: this.flag,
                i_image: this.form.image1,
                v_remarks: '',
            };
            this.$api.requestAPI(params).then( res =>{
                    if(res.IsSuccess){
                        this.$message.success(res.Message);  
                        this.initData(this.trainId)   
                        this.open = false     
                        this.userInfoOption= []  
                        this.form.sponsorId = ''    
                    }else{
                        this.$message.error(res.Message);
                    }  
                }).catch( error =>{
                    console.log(error);
                })  
        },
        cancel(){
            this.open = false
            this.resetForm('form')
        },
        searchQuery() {
            this.initData()
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        async querySearch(queryString, cb){
            let result = queryString ? await this.getUserInfoSearch(queryString) : []  
            cb(result)
        },
        // 模糊搜索查询
        getUserInfoSearch(val){
            return new Promise((resolve,reject)=>{
                if(val.length > 1){
                    let params = {
                        opcode: this.$code.UserInfoSearch,
                        v_name: val,
                        v_caption: '',
                        v_phone: '',
                    }
                    // 查询信息
                    this.$api._requestAPI(params).then(res => {
                        if (res.IsSuccess) {
                            let result = res.Data.DataTable
                            if(result.length === 0){
                                this.form.sponsorId = ''
                                // this.userInfoOption = []
                            }else{
                                let arr  = result.map(item=>{
                                    return{
                                        value:item['姓名'] +''+ item['手机号'],
                                        sponsorId: item['会员账号'],
                                        username: item['姓名'],
                                        phone: item['手机号'],
                                        role: item['角色'],
                                        level: item['星级']
                                }
                            })                            
                            // this.userInfoOption = arr.filter(i=>i.role === '掼蛋协会'||i.role === '掼蛋俱乐部')
                            resolve(arr)                         
                        }
                    }
                    }).catch(err => { reject(err)})
                }else{
                    this.form.sponsorId = ''
                }
            })         
        },
        handleSelect(row){
            this.form.sponsorName = row.username
            this.form.sponsorId = row.sponsorId
        },  
        // 模糊搜索查询
        getUserInfoSearch2(){
            console.log(this.form.sponsorName.length)
            if(this.form.sponsorName.length > 1){            
                let params = {
                    opcode: this.$code.UserInfoSearch,
                    v_name: this.form.sponsorName,
                    v_caption: '',
                    v_phone: '',
                }
                // 查询账户信息
                this.$api._requestAPI(params).then(res => {
                    if (res.IsSuccess) {
                        let result = res.Data.DataTable
                        if(result.length === 0){
                            this.form.sponsorId = ''
                            this.userInfoOption = []
                        }else{
                            this.userInfoOption = result.map(item=>{
                                return{
                                    value:item['会员账号'],
                                    label: item['会员账号'],
                                    phone: item['手机号'],
                                    role: item['角色'],
                                }
                            })    
                        }
                    }
                }).catch(err => {
                    console.log(err)
                })
            }
        },
        async handleRequest1(file,fileList){
            let url = await this.$help.uploadRequest(file)
            this.form.image1 = this.$global.uploadUrl + url
            this.fileList1 = [
                {name:file.file.name,url: this.form.image1 }
            ]
            this.loading.close();
            this.$refs.coverPicUpload1.clearFiles()
            console.log(this.form.image1)
        }, 
        handleRemove1(file, fileList) {
            this.form.image1 = ''
            this.fileList1 = []
        },
        handleBeforeUpload() {
            this.loading = true
            this.loading = this.$loading({
                lock: true,
                text: "上传中",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.loading.close();
        },
        handleUploadError() {
            // this.loading = false
            // this.$message({
            //     type: "error",
            //     message: "上传失败",
            // });
            // this.loading.close();
        },
    }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
</style>


// WEBPACK FOOTER //
// src/views/training/components/lecturer.vue